<template>
    <form method="post"
          :action="action"
          @submit.prevent="onSubmit"
          @keydown="form.errors.clear($event.target.name)">
        <div class="type mb-3">
            <div class="row blog-page">
                <div class="col-auto">
                    <div class="categories-block">
                        <span class="my-button ghost-but mr-3 " @click="form.type_form = 'visit'" :class="form.type_form == 'visit' ? 'active' : ''">
                            Заказать визит
                        </span>
                        <span class="my-button ghost-but " @click="form.type_form = 'call'" :class="form.type_form == 'call' ? 'active' : ''">
                            Заказать звонок
                        </span>
                    </div>
                </div>

            </div>
        </div>
        <div class="form-group my-input-item">
            <input type="text"
                   name="name"
                   class="form-control my-input-form my-input-form-grey"
                   :placeholder="Lang.get('common.name')"
                   v-model="form.name"
            >
            <span class="help is-danger text-danger"
                  v-if="form.errors.has('name')"
                  v-text="form.errors.get('name')">
            </span>
        </div>

        <div class="form-group my-input-item">
            <input type="text"
                   name="phone"
                   class="form-control my-input-form my-input-form-grey mobilephone-input-mask"
                   :placeholder="Lang.get('common.phone')"
                   v-model="form.phone"
            >
            <span class="help is-danger text-danger"
                  v-if="form.errors.has('phone')"
                  v-text="form.errors.get('phone')">
            </span>
        </div>
        <div class="form-group my-input-item" v-show="form.type_form == 'visit'">
            <input type="text"
                   name="name"
                   class="form-control my-input-form my-input-form-grey"
                   placeholder="Адрес"
                   v-model="form.adress"
            >
            <span class="help is-danger text-danger"
                  v-if="form.errors.has('adress')"
                  v-text="form.errors.get('adress')">
            </span>
        </div>


        <input class="my-button"
               type="submit"
               :disabled="form.errors.any()"
               :value="Lang.get('common.send')">
        <widget-loading v-if="form.loading" color="#03a9f4"></widget-loading>
    </form>
</template>

<script>
    import WidgetLoading from '../elements/WidgetLoading';

    export default {
        name: "trade-form",
        components: {
            WidgetLoading,
        },
        data() {
            return {
                form: new Form({
                    name: '',
                    phone: '',
                    adress: '',
                    type_form: 'visit',
                    type: 'trade-form',
                    url: location,
                    lang: siteLang,
                }),
                checkBot: '',
                action: '/trade-visit',
                Lang,
            }
        },
        methods: {
            onSubmit() {
              if(this.checkBot === '') {
                this.form.submit(this.$el.method, this.$el.action).then(res => {
                  document.querySelector('#trade-form').innerHTML = "<span class='success-sent-text text-center'>" + res + "</span>";
                }).catch(error => console.log(error));
              }
            },
        },
        mounted() {
            helpers.setInputMask('mobilephone');
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/forms/TradeForm.vue